import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Welcome from "@/pages/Welcome";
import Dashboard from "@/pages/Dashboard";
import LiveOps from "@/pages/LiveOps";
import Impact from "@/pages/Impact";
import Queue from "@/pages/Queue";
import ClientProfile from "@/pages/ClientProfile";
import Governance from "@/pages/Governance";
import Integrations from "@/pages/Integrations";
import Partnership from "@/pages/Partnership";
import WhiteLabel from "@/pages/WhiteLabel";
import Comparison from "@/pages/Comparison";
import Architecture from "@/pages/Architecture";
import Evaluation from "@/pages/Evaluation";
import ExecutiveView from "@/pages/views/ExecutiveView";
import OperationsView from "@/pages/views/OperationsView";
import ComplianceView from "@/pages/views/ComplianceView";
import JourneyView from "@/pages/views/JourneyView";
import TechnicalView from "@/pages/views/TechnicalView";
import Presentation from "@/pages/Presentation";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center" data-testid="session-loading">
        <div className="font-mono text-emerald-400 text-sm tracking-widest animate-pulse">INITIALISING SECURE SESSION…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/welcome" replace state={{ from: location.pathname + location.search }} />;
  return children;
};

function App() {
  useEffect(() => {
    document.title = "O.N.E.Tech | Forex Operational Intelligence Demo";
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/login" element={<Navigate to="/welcome" replace />} />
            <Route path="/presentation" element={<Protected><Presentation /></Protected>} />
            <Route path="/" element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="live" element={<LiveOps />} />
              <Route path="impact" element={<Impact />} />
              <Route path="views/executive" element={<ExecutiveView />} />
              <Route path="views/operations" element={<OperationsView />} />
              <Route path="views/compliance" element={<ComplianceView />} />
              <Route path="views/journey" element={<JourneyView />} />
              <Route path="views/technical" element={<TechnicalView />} />
              <Route path="queue" element={<Queue />} />
              <Route path="clients/:id" element={<ClientProfile />} />
              <Route path="governance" element={<Governance />} />
              <Route path="integrations" element={<Integrations />} />
              <Route path="partnership" element={<Partnership />} />
              <Route path="partnership/whitelabel" element={<WhiteLabel />} />
              <Route path="partnership/comparison" element={<Comparison />} />
              <Route path="partnership/architecture" element={<Architecture />} />
              <Route path="partnership/evaluation" element={<Evaluation />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster theme="dark" position="bottom-right" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
